import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilAtendente, usuarioPerfilRepresentante} from '../usuario/usuario-perfil';


/** Acessos permitidos à análise sell in */
export const acessosAnaliseSellIn: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilAtendente, usuarioPerfilRepresentante];

@Injectable()
export class CanActivateAnaliseSellIn implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosAnaliseSellIn);
    }
}
